; (function (w, $) {
  var plugin = {
    env: function () {
      var domin = window.Shopify.shop,
        reg = new RegExp("pro|demo", "i");
      return reg.test(domin) ? 'development' : 'production';
    },
    isExistDate: function (dateStr) { // yyyy/mm/dd
      const dateObj = dateStr.split('-');

      //列出12個月，每月最大日期限制
      const limitInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      const theYear = parseInt(dateObj[0]);
      const theMonth = parseInt(dateObj[1]);
      const theDay = parseInt(dateObj[2]);
      const isLeap = new Date(theYear, 1, 29).getDate() === 29; // 是否為閏年?

      if (isLeap) { // 若為閏年，最大日期限制改為 29
        limitInMonth[1] = 29;
      }

      // 比對該日是否超過每個月份最大日期限制
      return theDay <= limitInMonth[theMonth - 1]
    },
    isMobile: function () { //判断终端是否是手机
      var userAgentInfo = navigator.userAgent;
      var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod");
      return Agents.some(function (item) {
        return userAgentInfo.indexOf(item) > 0
      });
    },
    setCookie: function (name, value, time) { //设置cookie
      if (!name || !value) return;
      var Days = time || 30;
      var exp = new Date();
      exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
      document.cookie = name + "=" + encodeURIComponent(value) + ";expires=" + exp.toUTCString();
    },
    getCookie: function (name) { //获取cookie
      var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
      if (arr != null) return decodeURIComponent(arr[2]);
      return null;
    },
    getQuerysString: function () { //获取url中"?"符后的字串 
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    }
  }
  w.plugin = plugin;

  $.fn.loading = function (flag = true) {
    if (flag) {
      this.prop('disabled', true).children('i').css('display', 'inline-block');
    } else {
      this.prop('disabled', false).children('i').css('display', 'none');
    }
  }
}(window, jQuery))